var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 42,
    viewBox: "0 0 32 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2608 40.15C15.4538 42.3349 10.8621 40.1097 10.8621 35.7374V6.68844C10.8621 2.31622 15.6203 -0.416109 19.4249 1.76874L27.2257 5.88614C29.2693 6.99623 30.5384 9.12812 30.5384 11.4467C30.5384 16.2604 25.3537 19.3156 21.1076 17.0021L14.4371 13.4902L7.73873 9.6453C4.74906 7.92466 1 10.0767 1 13.5205V28.9079C1 32.3517 4.74655 34.5088 7.74377 32.7831L14.4421 28.9381L20.9285 25.2875C23.4868 23.7333 26.7817 24.1546 28.8682 26.2916C31.767 29.2712 31.0808 34.168 27.468 36.2444L19.2559 40.15H19.2608Z",
    stroke: "white",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1901 27.1549L12.6751 36.5478C9.67788 38.2684 5.93134 36.1162 5.93134 32.6725V9.77954C5.93134 6.33576 9.67788 4.17866 12.6751 5.90434L29.5812 14.8935",
    stroke: "white",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.dd8bfcffc7f521b460354c4557c53891.svg";
export { ForwardRef as ReactComponent };